import useListagemDividaAcordoColumns from "../../hooks/useListagemDividaAcordoColumns";
import { DividaAcordo } from "core/features/acordo/typings";
import NewTable from "ui/components/NewTable";
import { Text } from "@chakra-ui/layout";

function TabelaAcordoDivida({
  isLoading,
  data,
}: {
  data: DividaAcordo[];
  isLoading: boolean;
}) {
  const columns = useListagemDividaAcordoColumns();

  return (
    <>
      <Text fontSize="16px" fontWeight="bold" mb="16px">
        Receitas acordadas
      </Text>
      <NewTable<DividaAcordo>
        loading={isLoading}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    </>
  );
}

export default TabelaAcordoDivida;
